import {NgModule}              from '@angular/core';
import {CommonModule}          from '@angular/common';
import {PpLogfilesComponent}   from './components/pp-logfiles.component';
import {PpOverviewComponent}   from './components/pp-overview.component';
import {PpPlanningComponent}   from './components/pp-planning.component';
import {PpBookingComponent}    from './components/pp-booking.component';
import {PlantProtectionRoutes} from './plant-protection.routes';
import {ApDynComponentModule}  from '../ap-dyncomponent/ap-dyncomponent.module';

@NgModule({
  declarations: [
    PpLogfilesComponent,
    PpOverviewComponent,
    PpPlanningComponent,
    PpBookingComponent
  ],
  imports: [
    CommonModule,
    PlantProtectionRoutes,
    ApDynComponentModule
  ],
  providers: []
})
export class PlantProtectionModule {
}
